import React from 'react';
import { Image, ImageProps } from 'semantic-ui-react';
import { useEnvironment } from '../../contexts/EnvironmentContext';

export type Props = ImageProps;

export const POSImage: React.VFC<Props> = ({ src, ...props }) => {
  const env = useEnvironment();

  return <Image {...props} src={`${env.settings.cdnBaseUrl}/${src}`} />;
};
